import type { IconButtonProps } from '@mui/material/IconButton';

import { m } from 'framer-motion';

import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';

import { varHover } from 'src/components/animate';
import { nameToInitials, USER_INITIALS_AVATAR_BG } from 'src/utils/name-initials';

// ----------------------------------------------------------------------

export type AccountButtonProps = IconButtonProps & {
  displayName: string;
};

export function AccountButton({ displayName, sx, ...other }: AccountButtonProps) {
  const initials = nameToInitials(displayName);

  return (
    <IconButton
      component={m.button}
      whileTap="tap"
      whileHover="hover"
      variants={varHover(1.05)}
      sx={{ p: 0, ...sx }}
      {...other}
    >
      <Avatar
        alt={displayName}
        sx={{
          width: 40,
          height: 40,
          fontWeight: 700,
          fontSize: 14,
          color: 'common.white',
          bgcolor: USER_INITIALS_AVATAR_BG,
        }}
      >
        {initials}
      </Avatar>
    </IconButton>
  );
}
